export default __webpack_public_path__ + "static/media/org-insights-activity.c1c5db4f.png";